import {
  IPeriodSummary,
  IPeriodSkills,
  ITeamMemberPeriodSummary,
  ITeamMemberPeriodSkills,
} from "@/service/review-period";
import { Loader } from "@/shared/ui";

interface SummarySectionProps {
  summary?: IPeriodSummary | ITeamMemberPeriodSummary;
  skills?: IPeriodSkills | ITeamMemberPeriodSkills;
  isLoading?: boolean;
}

export const SummarySection = ({ summary, skills, isLoading }: SummarySectionProps) => {
  if (isLoading) {
    return (
      <div className="flex w-full items-center justify-center py-6">
        <Loader />
      </div>
    );
  }

  if (!summary?.overall_progress && !skills?.top_strengths?.length) {
    return null;
  }

  return (
    <div className="text-eerie-black grid grid-cols-1 gap-8 rounded-lg bg-slate-100 p-6 lg:grid-cols-[1fr_auto]">
      {summary?.overall_progress && (
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2 text-sm">
            <h3 className="font-bold">Overall Progress</h3>
            <p className="leading-relaxed">{summary.overall_progress}</p>
          </div>
        </div>
      )}
      {skills?.top_strengths?.length && (
        <div className="flex flex-col gap-3 lg:w-[310px]">
          <h3 className="text-xs font-semibold tracking-[-0.24px]">Top Strengths</h3>
          <ul className="flex list-disc flex-col gap-1.5 pl-5 text-sm">
            {skills.top_strengths.map((strength, index) => (
              <li key={index}>{strength.skill}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
